import usePageView from './usePageView';

const TrackPageView = ({ children, title }) => {
  usePageView(title);
  return children;
}

export default TrackPageView;
